import React, { FunctionComponent } from "react";
import { Typography, Button } from "@material-ui/core";
import "./index.scss";
import { Link } from "../../config/components";
import { ContentPageItemCollection } from "services/entities/content";
import ContentItem from "components/content/ContentItem";
import { Variant as ThemeVariant } from "@material-ui/core/styles/createTypography";

type Variant = ThemeVariant | "srOnly";

interface BackgroundAssetPosition {
  top?: string | any;
  right?: string | any;
  bottom?: string | any;
  left?: string | any;
}

type TitleTextProps = {
  title?: string | any;
  text?: string | any;
  code?: string | any;
  backgroundAsset?: string;
  backgroundAssetPosition?: BackgroundAssetPosition;
  backgroundAssetSize?: string;
  index?: number;
  imageLeft?: boolean;
  sectionTitle?: string | any;
  highlightedText?: string | any;
  link?: Link | undefined;
  titleVariant?: Variant | "inherit";
  sectionPadding?: string | any;
};

export const TitleText: FunctionComponent<TitleTextProps> = ({
  title,
  text,
  code,
  backgroundAsset,
  backgroundAssetPosition = {
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
  },
  backgroundAssetSize,
  index,
  sectionTitle,
  highlightedText,
  link,
  titleVariant = "h1",
  sectionPadding,
}) => {
  return (
    <>
      {code ? (
        <ContentItem code={code}>
          {(item) => {
            return (
              <section
                className={`section--title-text title-text-${index} ${sectionPadding}`}
              >
                <div
                  className="background-image"
                  style={{
                    top: backgroundAssetPosition.top,
                    right: backgroundAssetPosition.right,
                    bottom: backgroundAssetPosition.bottom,
                    left: backgroundAssetPosition.left,
                  }}
                >
                  {backgroundAsset && backgroundAsset.length && (
                    <img src={backgroundAsset} alt="box illustration" />
                  )}
                </div>
                <div className="grid content-mw">
                  {sectionTitle && (
                    <Typography
                      variant="h3"
                      component="h2"
                      className="section-title"
                    >
                      {sectionTitle}
                    </Typography>
                  )}
                  {(item as ContentPageItemCollection).title && (
                    <Typography
                      variant={titleVariant && titleVariant}
                      component="h2"
                      className="title"
                      dangerouslySetInnerHTML={{
                        __html:
                          highlightedText && highlightedText.length
                            ? `<span class="highlighted">${highlightedText}</span>  ${(
                                item as ContentPageItemCollection
                              ).title.toString()}`
                            : (
                                item as ContentPageItemCollection
                              ).title.toString(),
                      }}
                    />
                  )}
                  {(item as ContentPageItemCollection).text && (
                    <Typography
                      variant="body1"
                      component="div"
                      className="text"
                      dangerouslySetInnerHTML={{
                        __html: (
                          item as ContentPageItemCollection
                        ).text.toString(),
                      }}
                    />
                  )}
                  {((item as ContentPageItemCollection).link as Link) && (
                    <Button
                      className="link"
                      variant="outlined"
                      href={
                        ((item as ContentPageItemCollection).link as Link).url
                      }
                    >
                      {((item as ContentPageItemCollection).link as Link).label}
                    </Button>
                  )}
                </div>
              </section>
            );
          }}
        </ContentItem>
      ) : (
        <section className={`section--title-text title-text-${index}`}>
          <div className="grid content-mw">
            {sectionTitle && (
              <Typography
                variant={titleVariant}
                component="h2"
                className="section-title"
              >
                {sectionTitle}
              </Typography>
            )}
            <div
              className="background-image"
              style={{
                top: backgroundAssetPosition.top,
                right: backgroundAssetPosition.right,
                bottom: backgroundAssetPosition.bottom,
                left: backgroundAssetPosition.left,
              }}
            >
              {backgroundAsset && backgroundAsset.length && (
                <img src={backgroundAsset} alt="box illustration" />
              )}
            </div>
            {title && (
              <Typography
                variant="h1"
                component="h2"
                className="title"
                dangerouslySetInnerHTML={{
                  __html:
                    highlightedText && highlightedText.length
                      ? `<span class="highlighted">${highlightedText}</span>  ${title.toString()}`
                      : title.toString(),
                }}
              />
            )}
            {text && (
              <Typography
                variant="body1"
                component="div"
                className="text"
                dangerouslySetInnerHTML={{
                  __html: text.toString(),
                }}
              />
            )}
            {link && (
              <Button className="link" variant="outlined" href={link.url}>
                {link.label}
              </Button>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default TitleText;
